exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-list[data-v-ad36ecc6],.list-body[data-v-ad36ecc6]{white-space:nowrap;font-size:0;overflow:hidden}.list-body2[data-v-ad36ecc6]{display:inline-block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ad36ecc6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/plugin/index.vue
// module id = 4
// module chunks = 0